import { AppThunk } from './store'

export const delay = (ms: number) => new Promise<void>(resolve => setTimeout(resolve, ms))

// TODO: figure out a way to use store.subscribe here
// something like https://github.com/karl/redux-wait-for-state
export const waitForAnimationEnd =
  (id: number, maxWait = 2500): AppThunk<Promise<void>> =>
  (dispatch, getState) => {
    const start = Date.now()
    return new Promise(resolve => {
      const interval = setInterval(() => {
        const { animating } = getState().widgets[id]
        const elapsed = Date.now() - start
        if (!animating || elapsed >= maxWait) {
          clearInterval(interval)
          resolve()
        }
      }, 50) // start with delay to give animations a chance to kick off
    })
  }
